const contactLines = [
  { label: "Address", value: "Vijenac Ljube Babića 2" },
  { label: "City", value: "Osijek" },
  { label: "Zip", value: "31000" },
  { label: "Country", value: "Croatia" },
  { label: "Phone", value: "+385 976079483" },
  { label: "Email", value: "ceo@spinnetraffic.com" },
];

const footerColumns = [
  {
    title: "Engineering",
    items: ["iOS Platform", "System Architecture", "Performance", "Scalability"],
  },
  {
    title: "Practices",
    items: ["Clean Architecture", "Code Quality", "Testing", "Continuous Delivery"],
  },
  {
    title: "Focus",
    items: ["Usability", "Stability", "Innovation", "Long-Term Quality"],
  },
];

export default function ContactFooter() {
  return (
    <footer className="w-full bg-background-100 py-20 md:py-28">
      <div className="max-w-[1440px] mx-auto px-8 md:px-16">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">
          <div className="w-full lg:w-[40%]">
            <h2 className="text-4xl md:text-5xl font-extrabold text-foreground-950 font-heading leading-[1.1] mb-8">
              Get in<br />touch
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[340px] mb-12">
              Our team is based in Osijek, Croatia. Reach out for professional inquiries and engineering collaboration opportunities.
            </p>

            <div className="space-y-5">
              {contactLines.map((line) => (
                <div key={line.label} className="pb-4 border-b border-foreground-200/40">
                  <span className="block text-xs font-medium tracking-[0.1em] uppercase text-foreground-400 mb-1">
                    {line.label}
                  </span>
                  <span className="text-base md:text-lg font-medium text-foreground-900">
                    {line.value}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-[60%] flex flex-col justify-end">
            <div className="grid grid-cols-3 gap-8 md:gap-12">
              {footerColumns.map((column) => (
                <div key={column.title}>
                  <h4 className="text-sm font-semibold tracking-[0.08em] uppercase text-foreground-500 mb-6">
                    {column.title}
                  </h4>
                  <ul className="space-y-3">
                    {column.items.map((item) => (
                      <li key={item} className="text-sm text-foreground-600 leading-relaxed">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="mt-16 pt-8 border-t border-foreground-200/30">
              <p className="text-xs text-foreground-400">
                &copy; {new Date().getFullYear()} All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}